// use-sign-in-with-google.ts — Auth suite, action
//
// Initiates Google OAuth via Supabase (redirect-based).

'use client';

import { useMemo } from 'react';
import { supabase } from '@/lib/supabase';
import { useActionHook } from '@/lib/query/use-action-hook';
import type { ActionResult } from '@/types/async-protocol';

const GOOGLE_AUTH_PROVIDER = 'google';
const GOOGLE_ACCESS_TYPE_OFFLINE = 'offline';
const GOOGLE_AUTH_PROMPT_CONSENT = 'consent';

export function useSignInWithGoogle(): ActionResult<void, void> {
  return useActionHook<void, void>(
    useMemo(
      () => ({
        mutationFn: async () => {
          const { error } = await supabase.auth.signInWithOAuth({
            provider: GOOGLE_AUTH_PROVIDER,
            options: {
              redirectTo: `${window.location.origin}/auth/callback`,
              queryParams: {
                access_type: GOOGLE_ACCESS_TYPE_OFFLINE,
                prompt: GOOGLE_AUTH_PROMPT_CONSENT,
              },
            },
          });
          if (error) throw error;
        },
      }),
      [],
    ),
  );
}
